<template>
    <div class="qksm">
        <div class="nogap">
            <h4>（四）2021年部门省拨资金使用情况（不含已列入部门预算的省拨资金）</h4>
            <p>
                2021年
                <template v-for="(item,idx) in T2.省拨资金" :key="idx">
                    {{item.name}}{{idx+1 == T2.省拨资金.length ? `${isMoney(item.value*100)}%。` : `${isMoney(item.value)}万元，`}}
                </template>
            </p>
            <p v-if="isMoney(T2.省拨资金[3].value*100) != 100">
                执行率偏{{isMoney(T2.省拨资金[3].value*100) > 100 ? '高' : '低'}}，其原因:
                <reason type="textarea" rows="5" classname="qksm widest" name="Q4last" placeholder="一是...二是..." v-model:value="qksm['Q4last']"></reason>
            </p>
        </div>
    </div>
</template>
<script>
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm4Last",
        data() {
            return {
                isPdf: this.$parent.isPdf,
                qksm: this.$store.state.divData.qksm,
            }
        },
        props: {
            T2: {
                type: Object,
                default: "",
            },
        },
        components: {
            reason,
        },
    };
</script>